import { branchAction } from "../actionTypes";
const initialState = {
  branchList: [],
  branchDetails: null,
  loader: false,
  detailsLoader: false,
};

export default function branchReducer(state = initialState, { type, payload }) {
  switch (type) {
    case branchAction.BRANCH_LIST_INITIATE: {
      return {
        ...state,
        loader: true,
        branchList: [],
      };
    }
    case branchAction.BRANCH_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        branchList: payload,
      };
    }
    case branchAction.BRANCH_LIST_FAILURE: {
      return {
        ...state,
        loader: false,
        branchList: [],
      };
    }
    case branchAction.BRANCH_DETAILS_INITIATE: {
      return {
        ...state,
        detailsLoader: true,
        branchDetails: null,
      };
    }
    case branchAction.BRANCH_DETAILS_SUCCESS: {
      return {
        ...state,
        detailsLoader: false,
        branchDetails: payload,
      };
    }
    case branchAction.BRANCH_DETAILS_FAILURE: {
      return {
        ...state,
        detailsLoader: false,
        branchDetails: null,
      };
    }

    default:
      return state;
  }
}
